<template>
  <a-card class="container">
    <a-spin :spinning="spinning">
      <div class="form">
        <a-form ref="form" layout="horizontal" :form="form" :model="form">
          <a-row>
            <a-col :md="6" :sm="24">
              <a-form-item
                label="编码"
                :labelCol="{ span: 8 }"
                :wrapperCol="{ span: 16 }"
              >
                <a-input v-model.trim="form.code" placeholder="请输入角色编码" />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item
                label="等级"
                :labelCol="{ span: 8 }"
                :wrapperCol="{ span: 16 }"
              >
                <a-select v-model="form.level" allowClear>
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option
                    v-for="(item, index) in userLevelList"
                    :key="index"
                    :value="item"
                    >{{ item }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item
                label="状态"
                :labelCol="{ span: 8 }"
                :wrapperCol="{ span: 16 }"
              >
                <a-select
                  placeholder="请选择角色状态"
                  v-model="form.status"
                  allowClear
                >
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option
                    v-for="(item, index) in roleStatusList"
                    :key="index"
                    :value="item.value"
                    >{{ item.label }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-button type="primary" @click="search(1)">查询</a-button>
              <div class="space"></div>
              <a-button type="default" @click="reset()">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table">
        <div class="jstj">
          <a-button type="primary" @click="handleRoleSave">角色添加</a-button>
        </div>
        <standard-table
          :columns="columns"
          :dataSource="listData"
          :pagination="pagination"
          @change="onChange"
          :loading="loading"
        >
          <div slot="status" slot-scope="{ record }">
            <span
              class="status_tag"
              :style="{
                background: record.status == '0' ? '#1ab394' : '#ed5565',
              }"
            >
              {{ record.status == '0'?'正常':'停用'}}</span
            >
          </div>
          <div slot="operate" slot-scope="record">
            <a @click="handleRoleUpdate(record)">修改</a>&nbsp;
            <a @click="handleRoleDelete(record)"> 删除 </a>&nbsp;
          </div>
        </standard-table>
      </div>
      <div class="modal" v-show="visible">
        <a-modal
          v-model="visible"
          :title="modalTitle"
          @ok="handleOk"
          cancelText="取消"
          okText="保存"
          width="50%"
          :key="key"
        >
          <a-spin :spinning="spinning2">
            <a-form-model ref="roleForm" :model="roleForm" :rules="rules">
              <a-form-model-item
                label="菜单权限"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 10 }"
              >
                <a-tree-select
                  show-search
                  style="width: 100%"
                  @change="treeChange"
                  v-model="treeValue"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  placeholder="请选择"
                  allow-clear
                  tree-checkable
                  tree-default-expand-all
                >
                  <a-tree-select-node key="0" value="0" title="根目录">
                    <a-tree-select-node
                      v-for="item in treeData"
                      :key="item.id"
                      :value="item.id"
                      :title="item.name"
                    >
                      <a-tree-select-node
                        v-for="item2 in item.subMenus"
                        :key="item2.id"
                        :selectable="false"
                        :value="item2.id"
                        :title="item2.name"
                      />
                    </a-tree-select-node>
                  </a-tree-select-node>
                </a-tree-select>
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="角色编码"
                prop="code"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 10 }"
              >
                <a-input v-model.trim="roleForm.code" autocomplete="off" />
              </a-form-model-item>
              <a-form-model-item
                has-feedback
                label="角色描述"
                prop="desc"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 10 }"
              >
                <a-input v-model.trim="roleForm.desc" autocomplete="off" />
              </a-form-model-item>
              <a-form-model-item
                label="角色等级"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 10 }"
              >
                <a-select v-model="roleForm.level" allowClear>
                  <a-select-option
                    v-for="(item, index) in userLevelList"
                    :key="index"
                    :value="item"
                    >{{ item }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
              <a-form-model-item
                label="角色状态"
                :labelCol="{ span: 3 }"
                :wrapperCol="{ span: 10 }"
                v-show="modalTitle === '修改'"
              >
                <a-select
                  v-model="roleStatus"
                  allowClear
                >
                  <a-select-option :value="0">正常</a-select-option>
                  <a-select-option :value="1">停用</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-form-model>
          </a-spin>
        </a-modal>
      </div>
    </a-spin>
  </a-card>
</template>

<script>
import { roleStatusList } from "@/utils/enumeration.js";
import StandardTable from "@/components/StandardTable";
import {
  roleSearch,
  roleSave,
  userLevel,
  roleUpdate,
  roleDelete,
  roleIdMenuList,
} from "@/api/modules/systemManagement.js";
import { getMenuAll } from "@/api/api.js";
const columns = [
  {
    title: "角色编码",
    dataIndex: "code",
    align: "center",
    sortDirections: ["ascend", "descend"],
    defaultSortOrder: "ascend",
    sorter: (a, b) => a.code.localeCompare(b.code, "en"),
  },
  {
    title: "角色描述",
    dataIndex: "desc",
    align: "center",
    // ellipsis: true,
  },
  {
    title: "等级",
    dataIndex: "level",
    align: "center",
    sortDirections: ["ascend", "descend"],
    defaultSortOrder: "ascend",
    sorter: (a, b) => Number(a.level) - Number(b.level),
  },
  {
    title: "状态",
    dataIndex: "status",
    align: "center",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    align: "center",
    scopedSlots: { customRender: "createTime" },
    sortDirections: ["ascend", "descend"],
    defaultSortOrder: "descend",
    sorter: (a, b) => {
      return (
        Date.parse(a.createTime.replace(/-/g, "/")) -
        Date.parse(b.createTime.replace(/-/g, "/"))
      );
    },
    render: (value, record) => {
      return (
        <div>
          <Space>{record.createTime}</Space>
        </div>
      );
    },
  },
  {
    title: "操作",
    dataIndex: "operate",
    align: "center",
    scopedSlots: { customRender: "operate" },
  },
];
export default {
  name: "roleManagement",
  components: {
    StandardTable,
  },
  created() {
    this.getUserLevel();
    this.handleGetMenuAll();
    this.search(1);
  },
  data() {
    return {
      spinning: false,
      spinning2: false,
      loading: false,
      visible: false,
      roleStatusList,
      treeValue: [],
      roleStatusList2: [
        {
          label: "正常",
          value: "0",
        },
        {
          label: "停用",
          value: "1",
        },
      ],
      columns,
      modalTitle: "",
      roleId: "",
      roleStatus: 1,
      form: {
        code: "",
        level: "",
        status: "",
      },
      roleForm: {
        code: "",
        desc: "",
        level: "",
      },
      pagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        current: 1,
        showTotal: (total) => `共 ${total} 条`, //分页中显示总的数据
      },
      listData: null,
      userLevelList: null,
      treeData: null,
      key: 0,
      rules: {
        code: [{ required: true, message: "请输入角色编码", trigger: "blur" }],
        desc: [{ required: true, message: "请输入角色描述", trigger: "blur" }],
        // level: [
        //   { required: true, message: "请选择角色等级", trigger: "change" },
        // ],
        // status: [
        //   { required: true, message: "请选择角色状态", trigger: "change" },
        // ],
      },
    };
  },
  methods: {
    //分页查询
    search(val) {
      let params = {
        pageNum: val,
        pageSize: this.pagination.pageSize,
        code: this.form.code,
        level: this.form.level,
        status: this.form.status,
      };
      this.loading = true;
      roleSearch(params).then((res) => {
        if (res.code == "0000") {
          this.listData = res.data.list;
          this.pagination.total = res.data.totalCount;
          this.pagination.current = val;
        } else {
          this.$message.warn(res.msg);
        }
        this.loading = false;
      });
    },
    //重置
    reset() {
      for (let key in this.form) {
        if (this.form[key] !== "") {
          this.form[key] = "";
        }
      }
    },
    onChange(val) {
      this.pagination.current = val.current;
      this.search(this.pagination.current);
    },
    //添加角色
    handleRoleSave() {
      this.modalTitle = "添加";
      this.visible = true;
      this.key++;
      for (let index in this.roleForm) {
        if (this.roleForm[index] !== "") {
          this.roleForm[index] = "";
        }
      }
      this.treeValue = [];
    },
    //修改角色
    handleRoleUpdate(record) {
      this.key++;
      this.modalTitle = "修改";
      this.treeValue = [];
      this.roleId = record.record.id;
      this.roleStatus = record.record.status;
      this.roleForm = {
        code: record.record.code,
        desc: record.record.desc,
        level: record.record.level,
      };
      roleIdMenuList(record.record.id).then((res) => {
        let arr = res.data;
        for (let i = 0; i < arr.length; i++) {
          let subMenus = arr[i].subMenus;
          for (let j = 0; j < subMenus.length; j++) {
            if (subMenus[j].hasAuthority) {
              this.treeValue.push(subMenus[j].id);
            }
          }
        }
      });
      this.visible = true;
    },
    //删除角色
    handleRoleDelete(record) {
      let that = this;
      this.$confirm({
        title: "操作提示",
        content: "是否删除该用户信息？",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          let id = record.record.id;
          that.loading = true;
          roleDelete(id).then((res) => {
            if (res.code == "0000") {
              that.search(that.pagination.current);
              that.$message.success(res.msg);
            } else {
              that.$message.warn(res.msg);
            }
            that.loading = false;
          });
        },
      });
    },
    //添加或者修改提交
    handleOk() {
      let that = this;
      this.$refs["roleForm"].validate((valid) => {
        if (valid) {
          if (this.modalTitle == "添加") {
            let params = {
              role: Object.assign(this.roleForm),
              menuIds: this.treeValue,
            };
            this.spinning2 = true;
            roleSave("", params).then((res) => {
              this.spinning2 = false;
              if (res.code == "0000") {
                that.$message.success(res.msg);
                this.search(1);
              } else {
                that.$message.warn(res.msg);
              }
              this.visible = false;
            });
          } else if (this.modalTitle == "修改") {
            console.log(that.roleForm)
            let params = {
              role: {
                id: that.roleId,
                code: that.roleForm.code,
                desc: that.roleForm.desc,
                level: that.roleForm.level,
                status: that.roleStatus,
              },
              menuIds: this.treeValue,
            };
            this.spinning2 = true;
            roleUpdate("", params).then((res) => {
              this.spinning2 = false;
              if (res.code == "0000") {
                that.$message.success(res.msg);
                this.search(this.pagination.current);
              } else {
                that.$message.warn(res.msg);
              }
              this.visible = false;
            });
          }
        } else {
          return false;
        }
      });
    },
    //得到当前用户可以操作的用户等级
    getUserLevel() {
      let type = 1;
      userLevel(type).then((res) => {
        if (res.code == "0000") {
          this.userLevelList = [];
          for (let i = 0; i < res.data.length; i++) {
            if (
              !this.userLevelList.some((item) => item === res.data[i].level)
            ) {
              this.userLevelList.push(res.data[i].level);
            }
          }
        } else {
          this.$message.warn(res.msg);
        }
      });
    },
    //查询所有菜单
    handleGetMenuAll() {
      getMenuAll().then((res) => {
        if (res.code == "0000") {
          this.treeData = res.data;
        } else {
          this.$message.warn(res.msg);
        }
      });
    },
    treeChange(val) {
      this.treeValue = val;
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  .space {
    display: inline-block;
    margin: 0 5px;
  }
  .jstj {
    text-align: left;
    margin-bottom: 10px;
  }
  /deep/ .ant-modal-content {
    top: -50px;
  }
}
</style>